import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
/**
 * Verify and enable MFA
 */
export default async function verifyAndEnableMFA(userCode: string) {
  const res = await fetchOrchidAPI("/api/users/v1/enable_mfa/verify_code", {
    method: "POST",
    body: JSON.stringify({
      user_code: userCode,
    }),
  });
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return;
}
